export default __webpack_public_path__ + "static/media/prototype.c3f49bb5.svg";